<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">传道授业，携手成长</p>

        <p class="font2" style="padding-top: 4vh;">2025年你的线下授课时数共计<a class="font3">{{ this.totalHours }}</a>小时：</p>

        <p class="font2" style="padding-top: 2vh;"  v-for="(char, index) in lessonArray" :key="index">
            <a class="font3">{{ char.class_type }}</a>类课程
            <a class="font3">{{ char.class_num }}</a>门
            <a class="font3">{{ char.hours }}</a>小时，
            <a class="font3">{{ char.student_num }}</a>人参与
        </p>
        <p class="font2" style="padding-top: 4vh;margin: 0;">你传递的不只是知识，更是力量与温度。</p>
        <p class="font2" style="margin: 0;">分享让人闪光，也让自己发光。</p>
    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    data(){
        return{
            lessonArray:[],
            totalHours:0,
            classType:'',
            sutdentNum:0,
        }
    },
    created() {
        this.lessonArray = JSON.parse(this.ReportData.lesson)
        // console.log(this.lessonArray,'课程')
        this.lessonArray.forEach(element => {
        this.totalHours+=parseInt(element.hours)
        });
    }
}
</script>
  
<style scoped>
.body {
    background: 
        url("../../assets/25March/logo.png") right  top  no-repeat,
        url("../../assets/25June/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	width: 100%;
	height: 100vh;
}
.font1 {
    width: 96%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #26a5e1;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font2 { 
    width: 96%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #000;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #64892f;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25June/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .wrapper {
    width: 90%;
    margin: 0 auto;
    font-size: 19px;
  }
  .font2,.font3{
    font-size: 19px;
  }
}
</style>